export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: item.label,
      item: item.href ? `https://www.hanmanwang.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-3 flex-wrap">
        {items.map((item, idx) => (
          <span key={idx} className="flex items-center">
            {idx > 0 && (
              <span className="mx-2 text-foreground-300">/</span>
            )}
            {item.href && idx < items.length - 1 ? (
              <Link
                to={item.href}
                className="hover:text-primary-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className={idx === items.length - 1 ? 'text-foreground-800 font-medium' : 'text-foreground-500'}>
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </>
  );
}